<script lang="ts">
    import type { I18NMessage } from "@app/services/i18n.messages";

    import { getMessage } from "@app/services/i18n.service";
    import { onDestroy, onMount } from "svelte";

    export let onBackClick: () => void;
    export let message: I18NMessage | undefined = undefined;
    let oldHtmlTagHeight = "";
    let oldBodyTagHeight = "";
    let viewportHeight = window.visualViewport?.height,
        viewportWidth = window.visualViewport?.width;

    function updateWidthAndHeight() {
        viewportHeight = window.visualViewport?.height;
        viewportWidth = window.visualViewport?.width;
        
    }
    onMount(() => {
        oldHtmlTagHeight =
            document.getElementsByTagName("html")[0].style.height;
        oldBodyTagHeight = document.body.style.height;

        document.getElementsByTagName("html")[0].style.height = "100dvw";
        document.body.style.height = "100dvh";

        document.body.classList.add("noscroll");
        document.documentElement.style.overscrollBehavior = "none";
        window.visualViewport?.addEventListener("resize", updateWidthAndHeight);
        setTimeout(() => {
            window.scrollTo({ left: 0, top: 0, behavior: "instant" });
        }, 150);
    });
    onDestroy(() => {
        document.getElementsByTagName("html")[0].style.height =
            oldHtmlTagHeight;
        document.body.style.height = oldBodyTagHeight;

        document.body.classList.remove("noscroll");
        document.documentElement.style.overscrollBehavior = "";
        window.visualViewport?.removeEventListener(
            "resize",
            updateWidthAndHeight,
        );
    });

    function detectEscKeyPress(event: KeyboardEvent) {
        if (event.key === "Escape") {
            onBackClick();
        }
    }
    let container: HTMLDivElement;
    let width = 0,
        height = 0;
    setInterval(() => {
        if (container) {
            const box = container.getBoundingClientRect();
            width = box.width;
            height = box.height;
        }
    });
</script>

<svelte:window on:keypress={detectEscKeyPress} />
<div
    class="mobile-screen-container"
    bind:this={container}
    style={`height: ${viewportHeight}px; width: ${viewportWidth}px`}
>
    <div
        class="bg-white h-12 flex items-center text-slate-700 border-b border-slate-300"
    >
        <button
            class="py-1 text-base focus:outline-none px-2 h-10 w-10"
            on:click={onBackClick}
            ><span class="icon-tail-left" aria-label="Back" /></button
        >
        {#if message}
            <p>{getMessage(message)}</p>
        {/if}
        <slot name="navbar" />
    </div>
    <div class="bg-white mobile-screen-body">
        <slot />
    </div>
</div>

<style>
    .mobile-screen-container {
        overflow: auto;
        overscroll-behavior: none;
        height: 100vh;
        height: 100svh;
        height: 100dvh;
    }
</style>
